// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2EHjK","topBottomGutter":"Layout_topBottomGutter__VqE6Q"};